// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xf_a bhg_vn bhg_vf bhg_xb bhg_re bhg_tp bhg_qv"};